<template>
    <div class="fhv-centent" v-loading="loading" >
        <h4 class="title-topic">Inform manually report</h4>
         <div class="change">
            <label for="time">Destination Address：</label>
            <el-button type="primary" :disabled="$G_DEVICE_CFG.isReadOnly || flag" @click="sendData">Inform manually report</el-button>
        </div>

        <div class="change">
            <label for="time">Report the results:</label>
            <span v-text="result"></span>
        </div>
    </div>
    
</template>

<script>
export default {
  data() {
    return {
      loading:false,
      result: "",
      flag: false,
      informNum : 0,
      informMax : 2,
      isStatusOK : false,
    };
  },
  methods: {
    sendData() {
      let postData = {
        CmdType: "START_INFORM"
      };
      this.flag = true;
      this.loading=true;
      axios.post("/boafrm/tr069Inform", postData).then((res) => {
        this.loading=false
        let data = res.data;
        if (data.ret == "0") {
          this.result = "Results obtained in a later....";
          // 5s 过后去获取上报状态
          setTimeout(()=>{
            this.getInformResult();
          }, "5000");
        } else {

          this.$message.error("manually inform fail！");
          this.flag = false;
        }
      });
    },
    getInformResult() {
      let postData = {
        CmdType: "GET_INFORMRESULT"
      };
      let informVal = {
        "0": "manually inform success",
        "1": "No WAN interface specified for TR-069",
        "2": "WAN interface for TR-069 has no IP address",
        "6": "ACS URL invalid",
        "7": "ACS unreachable, CPE can't connect to ACS URL"
      };
      this.loading=true;
      axios.post("/boafrm/tr069Inform", postData).then(res => {
        this.loading=false;
        let data = res.data;
        if (data.ret == "0") {
          if (data.inform.status == "5") {
            this.isStatusOK = true;
            if (informVal[data.inform.result] != "undefined") {
              this.result = informVal[data.inform.result];
            }
            this.flag = false;
          } else {
            this.result = "Reporting!";
            // 状态是正在上报时 5s 过后再循环获取状态
            if (!this.isStatusOK) {
              setTimeout(()=> {
                this.getInformResult();
              }, "5000");
            }
          }
        } else {
          // 如果data.ret == -1 则重复没5s重复获取2次上报状态
          this.informNum++;
          if (this.informNum < this.informMax) {
            setTimeout(()=> {
              this.getInformResult();
            }, "5000");
          } else {
            this.result = "manually inform fail!Unknown error!";
            this.flag = false;
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.fhv-centent {
  .change {
    .el-button {
      height: 29px;
      font-size: 12px;
      line-height: 3px;
    }
  }
}
</style>




